import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'pcln-design-system'

const FindYourDealButton = (
  { currentProduct,
    formButtonProps,
    hasMinWidth,
    isLargeInput }) => {
  const buttonText = 'Find Your ' + currentProduct.charAt(0).toUpperCase() + currentProduct.slice(1, -1)
  return (
    <Button
      m={0}
      width={1}
      size='large'
      style={{
        whiteSpace: 'nowrap',
        minWidth: hasMinWidth ? '165px' : null,
        height: isLargeInput ? '56px' : null
      }}
      {...formButtonProps}
    >
      { buttonText }
    </Button>
  )
}

FindYourDealButton.propTypes = {
  formButtonProps: PropTypes.object,
  children: PropTypes.object,
  isLargeInput: PropTypes.bool,
  currentProduct: PropTypes.string,
  hasMinWidth: PropTypes.bool
}

FindYourDealButton.defaultProps = {
  hasMinWidth: false,
  currentProduct: ''
}

export default FindYourDealButton
